import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { ServiceTemplateType } from '~/models/service-template';
import { selectors } from '~/store/state-selectors';
const queryKeyFor = (type)=>type === ServiceTemplateType.Service ? QueryKeys.ServiceTemplates : QueryKeys.ServiceTemplateBundles;
export const useServiceTemplates = function useServiceTemplates(type) {
    let { refreshOnHookMount = false, enabled = true } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            queryKeyFor(type),
            businessId !== null && businessId !== void 0 ? businessId : ''
        ],
        queryFn: ()=>api.serviceTemplate.getAll(businessId, {
                includeDeleted: false,
                type: [
                    type
                ]
            }),
        enabled,
        refreshOnHookMount
    });
    return {
        data,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
